// © Microsoft Corporation. All rights reserved.

import { PopupData, SocialProps } from "../Social.props";
import { PopupTelemetryObjects, popupTelemetryActionDispatchers, popupTelemetryContracts } from "./Popup.telemetry";
import { addOrUpdateTelemetryObject, getPageContentType, renderHybrid } from "../Social.telemetry";

import FocusLock from "react-focus-lock";
import Main from "../main/main";
import React from "react";
import { SocialLocalizedStrings } from "../Social.localizedStrings";
import { TelemetryContentType } from "@msnews/telemetry-contracts";
import { close } from "../utils/icons";

export interface PopupProps extends SocialProps {
    popup?: PopupData;
    hideOverlay?: boolean;
    hideButtons?: boolean;
    t: SocialLocalizedStrings;
}

export default class Popup extends React.PureComponent<PopupProps> {
    telemetryObjects: PopupTelemetryObjects;

    constructor(props) {
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.closePopup();
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction);
    }

    closePopup() {
        if (this.props.popup && this.props.popup.popupProps && this.props.popup.popupProps["focusBackRef"]) {
            const ref = this.props.popup.popupProps["focusBackRef"];
            window.setTimeout(() => { ref.focus(); }, 50);
        }
        this.props.popupConnector.closePopup();
    }

    closeClickHandler(e) {
        popupTelemetryActionDispatchers.genericClicked(e.currentTarget, this.telemetryObjects && this.telemetryObjects.closeBtn);
        this.closePopup();
    }

    render() {
        const { popup, hideOverlay, hideButtons, responsiveClass, t, mainTelemetryObject } = this.props;
        if (!popup) { return null; }

        const { moduleName, popupProps } = popup;
        if (!moduleName) { return null; }
        // Override existing props from popup props
        const propsToPass = {...this.props, moduleName, ...popupProps };

        /** Generate Telemetry Objects */
        const parentTelemetryObject = popupProps && popupProps["parentTelemetryObject"];
        const contentType = parentTelemetryObject && parentTelemetryObject.contract && parentTelemetryObject.contract.content && parentTelemetryObject.contract.content.type == TelemetryContentType.Comment ?  TelemetryContentType.Comment : getPageContentType();
        this.telemetryObjects = {
            closeBtn: addOrUpdateTelemetryObject(mainTelemetryObject, {... popupTelemetryContracts.closeBtn }, {id: parentTelemetryObject && parentTelemetryObject.contract.content.id, type: contentType}, this.telemetryObjects && this.telemetryObjects.closeBtn)
        };

        return (
            <FocusLock>
                <div className={`${propsToPass.managedClasses.mainContainer} ${propsToPass.managedClasses.overlayContainer} ${responsiveClass}`}
                    role="dialog" aria-label={t.AriaLabelsPopup} aria-modal="true">
                    { !hideOverlay &&
            <div className="cwt-overlay" onClick={this.closePopup.bind(this)}>&nbsp;</div>
                    }
                    <div className="cwt-content">
                        { !hideButtons &&
              <div className="cwt-corner-buttons" style={ (popupProps && popupProps["cornerPosition"]) || {}}>
                  <a
                      role="button" aria-label={t.AriaLabelsClosePopupDialogue} title= "Close"
                      className="cwt-icon cwt-link cwt-close-popup-btn"
                      onClick={this.closeClickHandler.bind(this)}
                      {...renderHybrid(this.telemetryObjects.closeBtn, false)}
                  >{close}</a>
              </div>
                        }

                        <div className="cwt-content-container">
                            <Main {...propsToPass} requestContext={this.props.requestContext} />
                        </div>
                    </div>
                </div>
            </FocusLock>
        );
    }
}